import { FilesService, MediaShort } from '@insurance/api/requests'
import { ConditionalText } from '@shared/components'
import { downloadFile, showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { Button, ButtonProps } from 'antd'
import { DocumentDownload } from 'iconsax-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  file?: MediaShort | number | null
  onClickDownload?: () => Promise<Props['file']>
} & ButtonProps

export const DownloadButton = ({
  file,
  children,
  loading: btnLoading,
  onClickDownload,
  ...props
}: Props) => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const { mutateAsync: getFileDetails } = useMutation({
    mutationFn: FilesService.filesMediaRetrieve,
    onError: (error) => {
      showApiErrors(error)
      setLoading(false)
    }
  })

  if (!file) return <ConditionalText condition={false} />

  const onDownload = async () => {
    setLoading(true)

    const mediaFile = onClickDownload ? await onClickDownload() : file
    const fileId = typeof mediaFile !== 'object' ? mediaFile : null

    let fileDetails = typeof mediaFile === 'object' ? mediaFile : null

    if (fileId) fileDetails = await getFileDetails(fileId)

    if (fileDetails) downloadFile(fileDetails).finally(() => setLoading(false))
  }

  return (
    <Button
      type="link"
      onClick={onDownload}
      loading={btnLoading || loading}
      icon={<DocumentDownload size="16" />}
      {...props}
    >
      {children ?? t('download')}
    </Button>
  )
}
